export default __webpack_public_path__ + "static/media/screen1.525adb11.png";